import { memo } from "react";
import Pdf from "./Pdf";
import Toolbar from "./Toolbar";
import { getRects, setRects, useRects } from "./state/rects";
import { getPage, setPage, usePage, onPage } from "./state/page";
import { getSearch, setSearch, useSearch, onSearch } from "./state/search";
import { getHighlights, setHighlights, useHighlights } from "./state/highlights";
import { getDocument, setDocument, useDocument, onDocument } from "./state/document";
import { getSelection, setSelection, useSelection, onSelection } from "./state/selection";
import { getSearchResults, setSearchResults, useSearchResults } from "./state/searchResults";
import { getSearchIndex, setSearchIndex, useSearchIndex, onSearchIndex } from "./state/searchIndex";
import { getPages, setPages, usePages, getNumPages, setNumPages, useNumPages } from "./state/pages";
import { getScrollOffset, setScrollOffset, useScrollOffset, onScrollOffset } from "./state/scrollOffset";
Pdf.displayName = "Pdf";
Toolbar.displayName = `${Pdf.displayName}.Wave`;
Pdf.Mark = () => {};
Pdf.displayName = "Mark";
Pdf.Toolbar = /*#__PURE__*/memo(Toolbar);
Pdf.getPage = getPage;
Pdf.setPage = setPage;
Pdf.usePage = usePage;
Pdf.onPage = onPage;
Pdf.getPages = getPages;
Pdf.setPages = setPages;
Pdf.usePages = usePages;
Pdf.getRects = getRects;
Pdf.setRects = setRects;
Pdf.useRects = useRects;
Pdf.getNumPages = getNumPages;
Pdf.setNumPages = setNumPages;
Pdf.useNumPages = useNumPages;
Pdf.getSearch = getSearch;
Pdf.setSearch = setSearch;
Pdf.useSearch = useSearch;
Pdf.onSearch = onSearch;
Pdf.getDocument = getDocument;
Pdf.setDocument = setDocument;
Pdf.useDocument = useDocument;
Pdf.onDocument = onDocument;
Pdf.getSelection = getSelection;
Pdf.setSelection = setSelection;
Pdf.useSelection = useSelection;
Pdf.onSelection = onSelection;
Pdf.getHighlights = getHighlights;
Pdf.setHighlights = setHighlights;
Pdf.useHighlights = useHighlights;
Pdf.getSearchIndex = getSearchIndex;
Pdf.setSearchIndex = setSearchIndex;
Pdf.useSearchIndex = useSearchIndex;
Pdf.onSearchIndex = onSearchIndex;
Pdf.getSearchResults = getSearchResults;
Pdf.setSearchResults = setSearchResults;
Pdf.useSearchResults = useSearchResults;
Pdf.getScrollOffset = getScrollOffset;
Pdf.setScrollOffset = setScrollOffset;
Pdf.useScrollOffset = useScrollOffset;
Pdf.onScrollOffset = onScrollOffset;
export default Pdf;
//# sourceMappingURL=index.js.map